export default __webpack_public_path__ + "static/media/lds-logo_km.89226aac75921609.svg";